import React, { Fragment, useEffect, useState } from 'react'
import useAuth from '../../context/auth/useAuth'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { Container, Row, Col, Card, Modal } from 'react-bootstrap'
import { getCandidates } from '../../actions/candidatesActions'
import { CustomDataTable } from '../../components/design/Datatables/CustomDataTable'
import CandidateProfile from './CandidateProfile'
import { Link } from 'react-router-dom'

export default function Candidates() {
    const { t } = useTranslation()
    const {client} = useAuth()
	const dispatch = useDispatch()
	const {candidates} = useSelector(state=>state.candidates)
	const [modalShow, setModalShow] = useState(false)
    const [candidateToShow, setCandidateToShow] = useState({})
    const showCandidate = (candidateid) => {
		setCandidateToShow(candidates?.find(candidate => candidate.iduser === candidateid))
		setModalShow(true)
    }
	useEffect(() => {
		if(client){
			dispatch(getCandidates())
		}
	},[dispatch, t, client])

	const columnsCandidates = [
		{
			name: t('admin.dashboard.name'),
			id: 'id',
			cell: candidate =>
				<div className='text-left cursor' onClick={() => showCandidate(candidate.iduser)}>
					{candidate.firstname} {candidate.lastname}
				</div>,
			selector: (candidate) => candidate.name,
			sortable: true,
		},{
			name: t('admin.dashboard.availability'),
			center: 'true',
			cell: candidate =>
				<div>
                    {candidate.searching
						?
							<i className="fa fa-circle-check text-success" aria-hidden="true"></i>
						:
							<i className="fa fa-circle-xmark text-danger" aria-hidden="true"></i>
					}
				</div>,
			selector: (candidate) => candidate.searching,
			sortable: true,
		},{
			name: t('global.actions'),
			center: 'true',
			cell: candidate =>
				<div>
					<Link to={`/admin/candidate/profile/${candidate.iduser}`}>
						<img src="/images/menus/user.svg" alt="Icono Mi Perfil" className='me-3' />
					</Link>
					<Link to={`/admin/candidate/officialtitles/${candidate.iduser}`}>
						<img src="/images/menus/titulos.svg" alt="Icono Titulos Academicos" className='me-3' />
					</Link>
					<Link to={`/admin/candidate/careerpath/${candidate.iduser}`}>
						<img src="/images/menus/experiencia.svg" alt="Icono Experiencia Laboral" className='me-3' />
					</Link>
					<Link to={`/admin/candidate/competences/${candidate.iduser}`}>
						<img src="/images/menus/habilidades.svg" alt="Icono Habilidades" className='me-3' />
					</Link>
					<Link to={`/admin/candidate/ideal-position/${candidate.iduser}`}>
						<img src="/images/menus/idealPosition.svg" alt="Icono puesto ideal" className='me-3' />
					</Link>
				</div>,
			selector: (candidate) => candidate.marketing,
			sortable: true,
		}
	]

	return (
		<>
			<Container className='cuerpo'>
				<Row>
					<h1>{t('admin.dashboard.candidates')}</h1>
				</Row>
				<Row className="mt-2">
					<Col>
						<Card className='mb-5 sombra'>
                            <Card.Body className='px-5 pt-5'>
								<div className='d-flex justify-content-end'>
									<Link to="/admin/candidates/new" className='btn btn-primary'><i className='fas fa-plus me-2'/>{t("admin.dashboard.createCandidate")}</Link>
								</div>
								{candidates?.length > 0
									?
										<CustomDataTable columns={columnsCandidates} data={candidates} />
									:
										<>{t('admin.dashboard.thereisnotcandidates')}</>
								}
							</Card.Body>
						</Card>
					</Col>
				</Row>
			</Container>
			<Modal show={modalShow} dialogClassName="modal-90w" aria-labelledby="example-custom-modal-styling-title" centered>
                <Modal.Header>
                    <Modal.Title id="example-custom-modal-styling-title" className='w-100 d-flex justify-content-end'>
						<div>
							<i className='fa fa-times cursor' onClick={() => setModalShow(false)}></i>
						</div>
					</Modal.Title>
                </Modal.Header>
                <Modal.Body>
					<CandidateProfile candidateToShow={candidateToShow}/>
                </Modal.Body>
            </Modal>
        </>
    )
}